let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("da9e9")).then(() => parcelRequire('2uNdF'));